// extracted by mini-css-extract-plugin
export default {"wrapper":"ntf_wrapper__nQ0dY"};